import store from 'store';

import { DEVICE_TYPE, getEpgNowNext } from 'config/api';

import { setNowNextByChannelId } from 'store/programs/actions';
import { NowNextResponse } from 'store/railsBuilder/reducer.types';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';

async function fetchLiveProgram(channelId: string) {
    try {
        const response = await NagraInstance.get<NowNextResponse>(
            getEpgNowNext({
                channel: channelId,
                deviceType: DEVICE_TYPE,
            }),
        );

        const {
            data: {
                results: [
                    {
                        programmes: [liveProgram],
                    },
                ],
            },
        } = response;

        store.dispatch(setNowNextByChannelId(response.data));

        return liveProgram;
    } catch (error) {
        return undefined;
    }
}

export default fetchLiveProgram;
